
import { Filter } from "@/cms-services/filter";
import { FunnelStageLeadDataSource, ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import  ParamStringEditor from "../param-editors/string.vue";
import ParamTextEditor from "../param-editors/text.vue";
import ParamBoolEditor from "../param-editors/bool.vue";
import ParamNumberEditor from "../param-editors/number.vue";
import ParamDateTimeEditor from "../param-editors/date-time.vue";
import ParamEnumEditor from "../param-editors/enum.vue";
import _ from "lodash";
import moment from "moment";
import {Vue,Component, Prop, Ref, Watch} from "vue-property-decorator"
import draggable from "vuedraggable";

@Component({
    components:{
        draggable,
        ParamStringEditor,
        ParamTextEditor,
        ParamBoolEditor,
        ParamNumberEditor,
        ParamDateTimeEditor,
        ParamEnumEditor
    }
})
export default class FunnelStageLeads extends Vue {
    @Ref("form") form!:any
    @Prop() funnelStage:any
    @Prop() clientDataSource!:ListDataSource
    @Prop() leadClassDataSource!:ListDataSource
    

    clientLoading = false;
    editMode = false
    searchText = "";
    $message:any
    timeout:any
    dialog = false;
    updateDialog = false;
    clientDialog = false


    stageDataSource:ObjectDataSource = new ObjectDataSource({
        className:"LeadFunnelStage",
        id:0,
        config:{}
    })

    dataSource:FunnelStageLeadDataSource = new FunnelStageLeadDataSource({
        className:"FunnelStageLead",
        config:{}
    })

    leadDataSource:ObjectDataSource = new ObjectDataSource({
        className:"Lead",
        id:0,
        config:{}
    })

    model = {
        sum:0,
        caption:"",
        description:"",
        clientId:null,
        leadClassId:null,
        params:[]
    }

    clientModel = {
        firstName:"",
        lastName:"",
        patronymic:"",
        phoneNumber:"",
        email:"",
    }

    clientFields = [
        {
            name:"lastName",
            editor:"string",
            attrs:{
                label:"Фамилия",
            },
            grid:{cols:4}
        },
        {
            name:"firstName",
            editor:"string",
            grid:{cols:4},

            attrs:{
                label:"Имя",
            },
        },
        {
            name:"patronymic",
            editor:"string",
            grid:{cols:4},
            attrs:{
                label:"Отчество",
                hint:"",
                rows:5
            }
        },
        {
            name:"phoneNumber",
            editor:"string",
            grid:{cols:6},
            attrs:{
                mask:"+7 (###) ###-##-##",
                label:"Номер телефона",
            },
        },
        {
            name:"email",
            editor:"string",
            grid:{cols:6},
            attrs:{
                label:"Почта",
            },
        }
    ]

    fields = [
        {
            name:"caption",
            editor:"string",
            attrs:{
                label:"Заголовок",
            },
            grid:{cols:6}
        },
        {
            name:"sum",
            editor:"number",
            attrs:{
                label:"Сумма",
            },
            grid:{cols:6}
        },
        {
            name:"description",
            editor:"string",
            attrs:{
                label:"Описание",
                hint:"",
                rows:5
            }
        }
    ]

    actions = {
        getClients: async () => this.clientDataSource.items
    }

    colors = [
        ["#AAF0D1", "#B0E57C", "#D8BFD8", "#ADD8E6"],
        ["#90EE90", "#FFB6C1", "#FFA07A", "#F5DEB3"],
        ["#E6E6FA", "#F0E68C", "#B0C4DE", "#87CEFA"],
        ["#FF69B4", "#FFDAB9", "#EEE8AA", "#98FB98"],
        ["#AFEEEE", "#DB7093", "#F08080", "#FAFAD2"]
    ];

    get leadClass(){
        return this.leadClassDataSource.items.find(i => i.id == this.model.leadClassId);
    }

    get totalSum(){
        const sum = this.dataSource.items.reduce((acc, n) => acc+=n.lead.sum,0);
        return this.formatCurrency(sum);
    }

    formatCurrency(item){
        const num = Number(parseFloat(item).toFixed(0));
        return num.toLocaleString('ru-RU') ;
    }

    getEditor(leadClassParam:any){
        return leadClassParam?.editor ? `param-${leadClassParam?.editor}-editor` : null;
    }

    formatDate(item){
        return moment(item.lead.createDate).format("DD.MM.YYYY")
    }

    updateLeadParams(leadClassId:any){
        const leadClass = this.leadClassDataSource.items.find(i => i.id == leadClassId);
        if(!leadClass) return;
        this.model.params = leadClass.params.map((i:any) => ({
            caption:i.caption,
            leadClassId: leadClassId,
            leadClassParamId: i.id,
            value: "",
        }))
    }

    clear(){
        this.dialog = false;
        this.model.caption = "";
        this.model.sum = 0;
        this.model.description = ""
        this.model.clientId = null
    }

    @Watch("searchText")
    async searchClient(e){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
            this.clientLoading = true;
            this.clientDataSource.config.filter = JSON.stringify([
                new Filter("searchText", e)
            ])
            await this.clientDataSource.get();
            this.clientLoading = false;
        }, 100);
    }

    async selectClient(item:any) {
        this.leadDataSource.model.client = item;
        await this.leadDataSource.updateField({
            fieldName:"clientId",
            fieldValue:item.id
        })
        this.editMode = false;
        this.$message("Клиент успешно выбран")
    }

    async updateColor(event:any){
        if(event.hex == "#FF0000") return;
        
        await this.stageDataSource.updateField({
            fieldName:"color",
            fieldValue: event.hex
        })
    }

    async dragItem({added}:any){
        
        if(added?.element){
            console.log("updateStage");
            
            await this.dataSource.updateStage(added.element.id, this.funnelStage.id)
        }

        await this.dataSource.changePriority();
    }


    async add(){
        const valid = await this.form.validate();
        if(!valid){
            this.$message("Пожалуйста заполните форму корректно","error");
            return;
        }
        await this.dataSource.addLead(this.model,  this.funnelStage.leadFunnelId, this.funnelStage.id);
        
        this.clear();
    }

    clearClient(){
        this.clientDialog = false;
        this.clientModel.firstName="";
        this.clientModel.lastName="";
        this.clientModel.patronymic="";
        this.clientModel.phoneNumber="";
        this.clientModel.email="";
    }


    async addClient(){
        const result = await this.clientDataSource.add({...this.clientModel})
        this.model.clientId = result.id;
        this.searchText = result.fullName;
        this.clearClient();
    }

    async remove(item:any){
        await this.dataSource.remove(item.id);
    }

    async update(lead:any){
        this.leadDataSource.id=lead.id;
        this.leadDataSource.model = lead;
        this.updateDialog = true;
    }

    created(){
        this.stageDataSource.id = this.funnelStage.id;
        this.stageDataSource.model = this.funnelStage;
        this.dataSource.items = this.funnelStage.funnelStageLeads.sort((p: any, n: any) => p.priority - n.priority);
        this.model.leadClassId = this.leadClassDataSource.items.find(i => i.isDefault).id;

        this.updateLeadParams(this.model.leadClassId);  
    }
}
